export class AusstallenUmstallenFrageDialogResult {
    confirmed: boolean;
    result: 'umstallen' | 'ausstallen';
}
